import { CreditsType, CreditedPerson } from "../../types/CreditsType";

const articleCredits: CreditedPerson[] = [
    {
        name: "Sophie Esther Ramsey",
        position: "Handbook Editor-in-Chief",
        showPosition: true
    },
    {
        name: "Eleanor Yuneun Park",
        position: "Varsity Editor-in-Chief",
        showPosition: true
    },
    {
        name: "Divine Angubua",
        position: "Arts & Culture Editor",
        showPosition: true
    },
    {
        name: "Rubin Beshi",
        position: "Business & Labour Editor",
        showPosition: true
    },
    {
        name: "Charmaine Yu",
        position: "Opinion Editor",
        showPosition: true
    },
    {
        name: "Medha Surajpal",
        position: "Science Editor",
        showPosition: true
    },
    {
        name: "Selia Sanchez",
        position: "News Editor",
        showPosition: true
    },
    {
        name: "Olga (Olya) Fedossenko",
        position: "Assistant News Editor",
        showPosition: true
    },
    {
        name: "Isabella Reny",
        position: "Deputy Senior Copy Editor",
        showPosition: true
    },
    {
        name: "Ozair Chaudhry",
        position: "Senior Copy Editor",
        showPosition: true
    },
    {
        name: "Jake Takeuchi",
        position: "Sports Editor",
        showPosition: true
    },
    {
        name: "Ajeetha Vithiyananthan",
        position: "Managing Editor, Internal",
        showPosition: true
    },
    {
        name: "Kyla Cassandra Cortez",
        position: "Managing Editor, External",
        showPosition: true
    },
    {
        name: "Maeve Ellis",
        position: "Managing Editor, Online",
        showPosition: true
    },
    {
        name: "Simon Bettle",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Jevan Konyar",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Mari Khan",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Sanjuktha Vimal",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Zulal Tunc",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Ella Hamilton",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Druphadi Sen",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Sofia Tarnopolksy",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Tarushi Sahni",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Mehar Singh",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Bruno Macia",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Alyssa Ukani",
        position: "Contributor",
        showPosition: true
    },
    {
        name: "Aryan Chablani",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Brooke Schilling",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Bruno Macia",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Constantine Vrachas Matthaios",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Funmi Olaitan",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Jovana Radin",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Maram Qarmout",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Madison Truong",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Phong Tran",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Nora Zolfaghari",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Sierra Loh",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Sharon Chan",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Sofia Moniz",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Sophia Erenberg",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Vyusti Magan Shroff",
        position: "Copy Editor",
        showPosition: true
    },
    {
        name: "Andrew Hong",
        position: "Web Developer",
        showPosition: true
    },
    {
        name: "Emily Shen",
        position: "Web Developer",
        showPosition: true
    },
    {
        name: "Charel Suarez",
        position: "Web Developer",
        showPosition: true
    }
];

const visualCredits: CreditedPerson[] = [
    {
        name: "Kaisa Kasekamp",
        position: "Creative Director",
        showPosition: true
    },
    {
        name: "Vicky Huang",
        position: "Illustration Editor",
        showPosition: true
    },
    {
        name: "Milena Pappalardo",
        position: "Video Editor",
        showPosition: true
    },
    {
        name: "Evelyn Bolton",
        position: "Illustrator",
        showPosition: true
    },
    {
        name: "Elena Osipyuan",
        position: "Illustrator",
        showPosition: true
    },
    {
        name: "Biew Biew Sakulwannadee",
        position: "Illustrator",
        showPosition: true
    },
    {
        name: "Jishna Sunkara",
        position: "Illustrator",
        showPosition: true
    },
    {
        name: "Zuhal Olomi",
        position: "Illustrator",
        showPosition: true
    },
    {
        name: "Nilima Paul",
        position: "Illustrator",
        showPosition: true
    },
    {
        name: "Arthur Denyson Hamdani",
        position: "Visuals Contributor",
        showPosition: true
    },
    {
        name: "Jennifer Su",
        position: "Visuals Contributor",
        showPosition: true
    },
    {
        name: "Studio X",
        position: "Visuals Contributor",
        showPosition: true
    },
    {
        name: "Doris McCarthy Gallery",
        position: "Visuals Contributor",
        showPosition: true
    }
];

export const creditsData: CreditsType = {
    article_credits: articleCredits,
    visual_credits: visualCredits
};